export default __webpack_public_path__ + "static/financial-planning-b6022b474e2c0e71e85c35c644b77121.jpeg";